export const SET_BUTTON_CTA = 'service/SET_BUTTON_CTA';
export const SET_SHOW_ZIP_CODE_TEST = 'service/SET_SHOW_ZIP_CODE_TEST';
export const GET_A_PRICE_CLICK_SEGMENT = 'service/GET_A_PRICE_CLICK_SEGMENT';
export const LOW_TECH_COVERAGE_EMAIL_SUBMISSION = 'service/LOW_TECH_COVERAGE_EMAIL_SUBMISSION';
